var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('common-header',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]}),_c('router-view'),_c('common-footer',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }